import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBDataTable  } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalexpert from './Modalexpert';
import Commentexlist from './Commentexlist';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modalexpercommentpresent from './Modalexpercommentpresent';
import Swal from 'sweetalert2'
import Modalexpercommentpresentsm from './Modalexpercommentpresentsm';




export default class expertpresentsm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            extertype:'',
            expert_id:'',

            roompexpert_status:'', //สถานะการส่งคะแนนทั้งหมด
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.selectex = this.selectex.bind(this);
         this.dow = this.dow.bind(this);
         this.extertype = this.extertype.bind(this);
         this.list = this.list.bind(this);
         this.handleSubmitpass = this.handleSubmitpass.bind(this);
         this.selectstatussent = this.selectstatussent.bind(this);
      }


      componentDidMount() {

         setTimeout(() => {
           
          api.get('registercon/selectarticalmapforroom2sm/'+localStorage.getItem('id_roompresentsm')+'/'+localStorage.getItem('iduser') )
           .then(res => {
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('iduser')})
           }) 

         }, 0); 
         this.selectstatussent();   

      }

      list() {

        setTimeout(() => {
          
         api.get('registercon/selectarticalmapforroom2sm/'+localStorage.getItem('id_roompresentsm')+'/'+localStorage.getItem('iduser') )
          .then(res => {
            this.setState({ article: res.data})
            this.setState({ expert_id: localStorage.getItem('iduser')})
          }) 

        }, 0); 

     }


      selectex() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {

        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertat.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
             this.setState({ article: res.data})
           }) 

         }, 0);
      }


      extertype() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertattype.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
           //  console.log(res.data[0].expert_type);
           //  this.setState({ bankname: res.data, loading: false })
           //  this.setState({ extertype: res.data[0].expert_type})
           }) 

         }, 0);
      }


      updateat(){
        setTimeout(() => {
           
          Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
         .then(res => {
         //  console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

      dow(){
       
           
          if (localStorage.getItem('expert_id') !== null) {

              if (this.state.extertype === '1') {
                 window.open(
                    'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') ,
                    '_blank' // <- This is what makes it open in a new window.
                  );
              }else{
                window.open(
                  'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite2.php?expert_id='+localStorage.getItem('expert_id') ,
                  '_blank' // <- This is what makes it open in a new window.
                );

              }

           // window.location.href = 'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') 
           

        } else {
        }
      }

      selectstatussent() {

        setTimeout(() => {
         api.get('registercon/selectstatussentexpersm/'+localStorage.getItem('id_roompresentsm')+'/'+localStorage.getItem('iduser') )
          .then(res => {
            //this.setState({ statussentexper: res.data})
            if (res.data.length > 0 ) {
                this.setState({ roompexpert_status: res.data[0].roompexpert_statussm}) 
            }else{
                this.setState({ roompexpert_status: '1'}) 
            }
     
          // console.log(res.data)
          }) 

        }, 0); 

     }


      handleSubmitpass() {
        // alert('A name was submitted: ' + this.state.value);
       setTimeout(() => {
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("id_roompresentsm", localStorage.getItem('id_roompresentsm'));
          datafrm.append("id_expert", localStorage.getItem('iduser'));
         
          
          api.post("registercon/updatestatussentexpersm",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
       })
    
       .then(res => {
       
      
        if (res.data = '200') {

            Swal.fire({
                title: 'ส่งคะแนนสำเร็จ',
                text: "Score submitted successfully",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง'
              }).then((result) => {
                if (result.isConfirmed) {
                   window.location.href = '/expertpresentsm'
                  // Swal.fire(
                  //   'Deleted!',
                  //   'Your file has been deleted.',
                  //   'success'
                  // )
                 // this.props.list();
                  //this.toggle()
                 // this.list();
                }
              })
        
        }else{
                 message.error("อัพโหลไฟล์ไม่สำเร็จ!")
           }
      })
    }, 1000);
      }



    render() {


        const datast = {
            columns: [
              {
                label: '#',
                field: 'list',
                sort: 'list',
                width: 150
              },
              {
                label: 'ชื่อบทความ',
                field: 'name_expert',
                sort: 'name_expert',
                width: 150
              },
              {
                label: 'กลุ่ม',
                field: 'username_expert',
                sort: 'username_expert',
                width: 150
              },
              {
                label: 'ชื่อผู้นำเสนอ',
                field: 'name_present',
                sort: 'name_present',
                width: 150
              },
              {
                label: 'จัดการคะแนน',
                field: 'name_presentd',
                sort: 'name_presentd',
                width: 150
              },
              {
                label: 'สถานะ',
                field: 'name_presentdst',
                sort: 'name_presentdst',
                width: 150
              },
            
          
            ],
      
      
            rows: [...this.state.article.map((data, i) => (
              {
                 list: <>{i+1}</>,
                 name_expert: <>{data.name_articlesm} <br/>
                  <MDBBtn color="unique" size="sm" href={`https://mua.kpru.ac.th/FrontEnd_Conferencekpru/${data.send_uploadepdf1sm	}`}  target="_blank">ไฟล์บทความ</MDBBtn>
                 </>,
                 username_expert: <>{data.presentype_name}</>,
                 name_present: <>{data.name_presentsm}</>,
                 name_presentd: <>
                 {this.state.roompexpert_status === '2'?<>
                    <MDBBtn color="deep-purple"  size='sm' disabled>ประเมินบทความ</MDBBtn>
                    </>:<>
                    <Modalexpercommentpresentsm id_send={data.id_send} name_article ={data.name_articlesm} id_expertex={localStorage.getItem('iduser')}  id_roompresent={localStorage.getItem('id_roompresentsm')} list={this.list} />
                    </>}
                 </>,
                 name_presentdst: <>{data.scool > 0 || data.scool != null ?<><MDBIcon icon="check" className="green-text pr-3"/>บันทึกคะแนนแล้ว</>:<> <MDBIcon icon="hourglass" /></> }</>,
              }
             ))]
        
            };
                const persons = <MDBDataTable
              // searching ={true}
                searchLabel="ค้นหา ชื่อบทความ"
                striped
                bordered
                small 
                entries={50}
              // entriesOptions={["10", "20"]}
                order={["age", "desc"]}
                data={datast}
                entriesLabel="จำนวนที่แสดง "
                infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                responsive 
                sortRows={['random']}
                 theadColor="grey lighten-1"
              //  theadColor={"#ff4444"}
                />

        return (
            <MDBContainer>
            <div>
            <h4 className="text-center font-weight-bold">ยินดีต้อนรับ : {localStorage.getItem('nameuser')} (ผู้ทรงคุณวุฒิประจำห้อง สัมมนา)</h4>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
            {/* <Alert message="แบบพอร์มสำหรับพิจารณาบทความ" type="info" /> */}
            {/* <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>รายการ</th>
                        <th>ไฟล์เอกสาร</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                   
                        <tr>
                        <td>1</td>
                        <td>แบบตอบรับการเป็นผู้ทรงคุณวุฒิ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp2.pdf"> <MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>คำชี้แจงการเขียนบทความ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp3.pdf"> <MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>หนังสือขอความอนุเคราะห์ตรวจบทความ</td>
                        <td>{this.state.extertype === '1' || this.state.extertype === '2' ? <><MDBBtn color="primary" size="sm" onClick={this.dow}>Download</MDBBtn></> : <></>}</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>แบบประเมิน บทความวิจัย สาขามนุษยศาสตร์และสังคมศาสตร์</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/hum1.docx"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                      
                        <tr>
                        <td>5</td>
                        <td>แบบประเมิน บทความวิจัย  สาขาวิทยาศาสตร์และเทคโนโลยี</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/sai1.docx"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr> 
                        <tr> 
                        <td>6</td>
                        <td>ใบสำคัญรับเงิน</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/money.pdf"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>7</td>
                        <td>คู่มือการการใช้งานระบบ สำหรับผู้ทรงคุณวุฒิ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp1.pdf" target="_blank" ><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                    
                    </MDBTableBody>
                </MDBTable> */}



               {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความเข้าใหม่</h2>
                </MDBAlert> */}
                     <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="บทความสัมมนา"
                                    subTitle="บทความบทความสัมมนา สำหรับตรวจ"
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                            </MDBAlert>  

                            {persons}
                            {this.state.roompexpert_status === '2'?<>
                              <div className='text-center'><MDBBtn color="primary" disabled>ส่งผลคะแนนทั้งหมดแล้ว (ไม่สามารถแก้ไขข้อมูลได้)</MDBBtn></div> 
                            </>:<>
                              <div className='text-center'><MDBBtn color="primary" onClick={this.handleSubmitpass} >ส่งผลทั้งหมด</MDBBtn> <p>(ส่งข้อมูลแล้วจะไม่สามารถแก้ไขข้อมูลได้)</p></div> 
                            </>}
                         

            </div>
            </MDBContainer>
        )
    }
}
